import { render, staticRenderFns } from "./langues.vue?vue&type=template&id=2fbd705d&"
import script from "./langues.vue?vue&type=script&lang=js&"
export * from "./langues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports